import './assets/styles/main.scss';
import 'vue-toastification/dist/index.css';
import 'floating-vue/dist/style.css';

import HoneybadgerVue from '@honeybadger-io/vue';
import FloatingVue from 'floating-vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import Toast from 'vue-toastification';

import { loadScript } from '@/utils/dom';
import eventBus from '@/utils/eventBus';
import { honeybadgerConfig } from '@/utils/honeybadger';
import { i18nConfig } from '@/utils/i18n';

import App from './App.vue';
import router from './router';

const intercomJsUrl = `${import.meta.env.VITE_ACCOUNTS_BASE_URL}intercom.js`;
loadScript(intercomJsUrl);

const app = createApp(App);

if (honeybadgerConfig && import.meta.env.VITE_MODE !== 'local') {
  app.use(HoneybadgerVue, honeybadgerConfig);
}

app.use(createPinia());
app.use(router);
app.use(i18nConfig);
app.use(FloatingVue);
app.use(Toast, {
  maxToasts: 1,
  newestOnTop: true,
  position: 'top-center',
  draggable: false,
  pauseOnHover: false,
  timeout: 2000,
  hideProgressBar: true,
  icon: false,
  closeButton: false,
  containerClassName: 'toast-container'
});

app.config.globalProperties.eventBus = eventBus;
app.mount('#app');
